/**
 * Build the Annotate-modal "Available tags" list.
 *
 * Session-created tags stay in creation order at the end so they don't jump
 * into the alphabetical slot. Deleted tags are excluded even if get-labels
 * still returns them (original_entity_names) until the parent list refreshes.
 */
export function buildNerAvailableTags(
    entityOptions = [],
    categoryCounts = {},
    newlyAddedTags = [],
    removedTags = [],
) {
    const removed = new Set(removedTags);
    const all = Array.from(
        new Set([...entityOptions.map((e) => e.value), ...Object.keys(categoryCounts)]),
    ).filter((c) => !removed.has(c));
    const isNew = new Set(newlyAddedTags);
    const sorted = all.filter((c) => !isNew.has(c)).sort((a, b) => a.localeCompare(b));
    const appended = newlyAddedTags.filter((c) => all.includes(c));
    return [...sorted, ...appended];
}
